import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import {Row} from "react-bootstrap"
import styled from "styled-components"

import notify from "@irati/utils/notify"
import authentication from "@irati/auth"
import id from "@irati/utils/id"
import UserSearch from "@irati/ui/src/UserSearch"
import {validatedScreen} from "@irati/utils/validation"
import {injectIntl} from "@irati/utils/lang"
import {addUserToSchedule} from "@irati/insights/services/schedule/addUserToSchedule"
import padding from "@irati/ui/src/global/padding"
import {Para} from "@irati/ui/src/Labels"

import tracking from "../../../tracking/survey"
import Modal from "../../../ui/Modal/Modal"

const SpacedRow = styled(Row)`
  padding-top: ${padding.base};
`

class SendExampleSurvey extends PureComponent {
  static propTypes = {
    formatMessage: PropTypes.func.isRequired,
    scheduleId: PropTypes.string.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      showModal: false,
      formData: this.getDefaultFormData(),
      showConfirmationModal: false
    }
  }

  getDefaultFormData = () => {
    return {
      scheduleId: this.props.scheduleId,
      user: {},
      tenant: authentication.userTenant().uuid
    }
  }

  handleAction = () => {
    this.showModal()
  }

  showModal = () => {
    this.setState((prevState) => ({
      showModal: !prevState.showModal
    }))
  }

  closeModal = () => {
    this.setState((prevState) => ({
      showModal: !prevState.showModal,
      formData: this.getDefaultFormData()
    }))
  }

  closeConfirmationModal = () => {
    this.setState((prevState) => ({
      showConfirmationModal: !prevState.showConfirmationModal
    }))
  }

  hideModalAndResetFormData = () => {
    this.setState((prevState) => ({
      showModal: !prevState.showModal,
      formData: this.getDefaultFormData(),
      loading: !prevState.loading,
      showConfirmationModal: !prevState.showConfirmationModal
    }))
  }

  onSubmit = () => {
    this.setState((prevState) => ({
      loading: !prevState.loading
    }))
    return addUserToSchedule(this.state.formData)
      .then(() => {
        this.hideModalAndResetFormData()
      })
      .catch((error) => {
        tracking.errorsEmployeeEngagement()
        notify.error({message: error.message, position: "top-right"})
        this.setState((prevState) => ({
          loading: !prevState.loading
        }))
      })
  }

  handleSelect = (_, user) => {
    this.setState((state) => ({formData: {...state.formData, user}}))
  }

  handleSubmit = () => {
    tracking.sendTestSurvey()
    this.onSubmit()
  }

  render() {
    const idNamespace = id("send-example-survey", this.props)
    const {formatMessage} = this.props
    const {showModal, showConfirmationModal, loading} = this.state

    return (
      <div>
        {!showConfirmationModal && (
          <Modal
            id={idNamespace}
            primary={{
              text: formatMessage({id: "insights.schedule.sendExampleSurvey.button.label"}),
              onClick: this.handleSubmit
            }}
            secondary={{
              text: formatMessage({id: "insights.schedule.sendExampleSurvey.secondaryButton.label"}),
              onClick: this.closeModal
            }}
            show={showModal}
            handleClose={this.closeModal}
            loading={loading}
            title={formatMessage({id: "insights.schedule.sendExampleSurvey.button.label"})}>
            {formatMessage({id: "insights.schedule.sendExampleSurvey.modal.body"})}
            <SpacedRow>
              <UserSearch
                id={id("userId", idNamespace)}
                onChange={this.handleSelect}
                placeholder={formatMessage({id: "insights.user.search.placeHolder"})}
                label={formatMessage({id: "insights.schedule.settings.user.search.label"})} />
            </SpacedRow>
          </Modal>
        )}
        {showConfirmationModal && (
          <Modal
            primary={{
              text: formatMessage({id: "insights.sendExampleSurvey.confirmation.cta"}),
              onClick: this.closeConfirmationModal
            }}
            title={formatMessage({id: "insights.sendExampleSurvey.confirmation.title"})}
            handleClose={this.closeConfirmationModal}
            loading={loading}
            show={showConfirmationModal}>
            <Para>{formatMessage({id: "insights.sendExampleSurvey.confirmation.lineOne"})}</Para>
            <Para>{formatMessage({id: "insights.sendExampleSurvey.confirmation.lineTwo"})}</Para>
          </Modal>
        )}
      </div>
    )
  }
}

export default validatedScreen(injectIntl(SendExampleSurvey, {withRef: true}), "SendExampleSurvey", {withRef: true})
